import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";

import FreightMasterMain from "./FreightMaster/FreightMasterMain"; // Normal import

// Lazy load everything else
const Teams = lazy(() => import("./Teams/Teams"));
const GeneralInformation = lazy(() =>
  import("./GeneralInformation/GeneralInformation")
);
const Settings = lazy(() => import("./CompanySettings/Settings"));
const MyTransporters = lazy(() => import("./MyTransporters/MyTransporters"));
const Operations = lazy(() => import("./OperationsOverview/Operations"));
const TermsAndConditions = lazy(() => import("./TNC/TermsAndConditions"));
const RfqDetails = lazy(() => import("./RfqDetails/RfqDetails"));
const ReportGenerator = lazy(() => import("./ReportGenerator/ReportGenerator"));

const CompanyProfileRoutes = () => {
  return (
    <Suspense fallback={<div></div>}>
      <Switch>
        <Route
          path="/companyprofilenew/generalinfo"
          component={GeneralInformation}
          exact
        />
        <Route path="/companyprofilenew/team" component={Teams} exact />

        {/* FreightMaster stays normal */}
        <Route
          path="/companyprofilenew/masters/:id"
          component={FreightMasterMain}
        />

        <Route
          path="/companyprofilenew/tnc"
          component={TermsAndConditions}
          exact
        />
        <Route
          path="/companyprofilenew/operations"
          component={Operations}
          exact
        />
        <Route
          path="/companyprofilenew/transporters"
          component={MyTransporters}
          exact
        />
        <Route path="/companyprofilenew/settings" component={Settings} exact />
        <Route
          path="/companyprofilenew/rfqdetails"
          component={RfqDetails}
          exact
        />
        <Route
          path="/companyprofilenew/reports"
          component={ReportGenerator}
          exact
        />
      </Switch>
    </Suspense>
  );
};

export default CompanyProfileRoutes;
